import { render, staticRenderFns } from "./WorkplaceMaterialCompanyList.vue?vue&type=template&id=20110e21&scoped=true"
import script from "./WorkplaceMaterialCompanyList.vue?vue&type=script&lang=js"
export * from "./WorkplaceMaterialCompanyList.vue?vue&type=script&lang=js"
import style0 from "./WorkplaceMaterialCompanyList.vue?vue&type=style&index=0&id=20110e21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20110e21",
  null
  
)

export default component.exports